import React, { useEffect, useRef } from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo.svg";
import { animate } from "framer-motion";
import { InView } from "react-intersection-observer";

const Footer = () => {
  const [isInView, setIsInView] = React.useState([]);
  function handleInView(SectionName, InView) {
    if (InView) {
      setIsInView((isInView) => [...isInView, SectionName]);
    }
  }

  // eslint-disable-next-line react/prop-types
  function Counter({ from, to }) {
    const nodeRef = useRef();
    useEffect(() => {
      const node = nodeRef.current;

      const controls = animate(from, to, {
        duration: 1,
        onUpdate(value) {
          node.textContent = value.toFixed(0);
        },
      });

      return () => controls.stop();
    }, [from, to]);

    return <span ref={nodeRef} />;
  }
  return (
    <div className='Footer'>
      <div className='wrapper'>
        {
          <InView
            as='div'
            style={{
              display: "flex",
              flexDirection: "column",
            }}
            onChange={(inView) => handleInView("boxes", inView)}
            triggerOnce></InView>
        }
        {isInView.includes("boxes") && (
          <div className='upper'>
            <div className='wrap'>
              <div className='box short'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='40'
                  height='40'
                  viewBox='0 0 40 40'
                  fill='none'>
                  <g clipPath='url(#clip0_28_1724)'>
                    <path
                      d='M38.5696 22.8577V30.0006C38.5696 30.3794 38.419 30.7428 38.1513 31.0108C37.8833 31.2786 37.5199 31.4291 37.141 31.4291H2.85533C2.47645 31.4291 2.11309 31.2786 1.84518 31.0108C1.57727 30.7428 1.42676 30.3794 1.42676 30.0006V7.14341C1.42676 6.76453 1.57727 6.40116 1.84518 6.13327C2.11309 5.86536 2.47645 5.71484 2.85533 5.71484H8.56962'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M17.1413 31.4292L14.2842 38.5721'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M22.8555 31.4292L25.7126 38.5721'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M11.4268 38.5718H28.5696'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M15.7119 15.7149H24.2833V21.4292L32.8548 15.7149H38.5691V1.4292H15.7119V15.7149Z'
                      fill='#FC7A01'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_28_1724'>
                      <rect width='40' height='40' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
                <p className='title'>Live customer service</p>
              </div>
              <div className='box short'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='41'
                  height='42'
                  viewBox='0 0 41 42'
                  fill='none'>
                  <path
                    d='M39.2714 10.7889C39.2149 10.4746 39.0945 10.1759 38.9179 9.91226C38.7413 9.64868 38.5126 9.42608 38.2464 9.25892L32.3892 15.2589C32.116 15.5493 31.7886 15.7802 31.4263 15.938C31.0641 16.0957 30.6743 16.177 30.2807 16.177C29.8871 16.177 29.4976 16.0957 29.1352 15.938C28.7729 15.7802 28.4454 15.5493 28.1722 15.2589L25.9465 13.2189C25.4099 12.6581 25.1093 11.9042 25.1093 11.1189C25.1093 10.3337 25.4099 9.57971 25.9465 9.01892L31.8035 3.01892C31.6758 2.71154 31.4837 2.43666 31.2409 2.21374C30.9979 1.99083 30.7103 1.82532 30.3978 1.72893C28.3542 1.31145 26.2372 1.49015 24.2879 2.2447C22.3385 2.99924 20.6352 4.29929 19.3717 5.99687C18.1082 7.69445 17.3354 9.72134 17.1413 11.8468C16.9594 13.8377 17.2922 15.8402 18.1029 17.6542L2.38608 33.7541C1.22587 34.9427 1.24511 36.8756 2.42874 38.0396L4.07103 39.6548C5.21651 40.7813 7.02973 40.7675 8.15867 39.6233L24.0559 23.5148C25.7753 24.2422 27.6483 24.5189 29.5043 24.3151C31.5563 24.0897 33.5074 23.2857 35.14 21.9924C36.773 20.6991 38.0235 18.9672 38.7527 16.9893C39.4822 15.0114 39.6618 12.8651 39.2714 10.7889Z'
                    fill='#FC7A01'
                    stroke='#FC7A01'
                    strokeWidth='1.71429'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='title'>
                  <Counter from={0} to={35} />+ years of expertise
                </p>
              </div>
              <div className='box'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='40'
                  height='40'
                  viewBox='0 0 40 40'
                  fill='none'>
                  <g clipPath='url(#clip0_28_1742)'>
                    <path
                      d='M24.2842 15.7148H32.8556C34.371 15.7148 35.8245 16.3169 36.8962 17.3885C37.9679 18.4602 38.5699 19.9136 38.5699 21.4291V32.8577H34.2842'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M4.2839 32.8576H1.42676V12.8576C1.42676 12.0999 1.72778 11.3731 2.2636 10.8373C2.79941 10.3015 3.52613 10.0005 4.2839 10.0005H21.4268C22.1845 10.0005 22.9112 10.3015 23.4471 10.8373C23.9829 11.3731 24.2839 12.0999 24.2839 12.8576V32.8576'
                      fill='#FC7A01'
                    />
                    <path
                      d='M4.2839 32.8576H1.42676V12.8576C1.42676 12.0999 1.72778 11.3731 2.2636 10.8373C2.79942 10.3015 3.52613 10.0005 4.2839 10.0005H21.4268C22.1845 10.0005 22.9112 10.3015 23.4471 10.8373C23.9829 11.3731 24.2839 12.0999 24.2839 12.8576V32.8576'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M22.8548 32.8579H15.7119H22.8548Z'
                      fill='#FC7A01'
                    />
                    <path
                      d='M22.8548 32.8579H15.7119'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M29.2842 38.5723C26.5228 38.5723 24.2842 36.3337 24.2842 33.5723C24.2842 30.8108 26.5228 28.5723 29.2842 28.5723C32.0456 28.5723 34.2842 30.8108 34.2842 33.5723C34.2842 36.3337 32.0456 38.5723 29.2842 38.5723Z'
                      fill='#FC7A01'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M9.99805 38.5723C7.23662 38.5723 4.99805 36.3337 4.99805 33.5723C4.99805 30.8108 7.23662 28.5723 9.99805 28.5723C12.7595 28.5723 14.998 30.8108 14.998 33.5723C14.998 36.3337 12.7595 38.5723 9.99805 38.5723Z'
                      fill='#FC7A01'
                      stroke='#FC7A01'
                      strokeWidth='2.85714'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_28_1742'>
                      <rect width='40' height='40' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
                <p className='title'>Same-day after-hours emergency services</p>
              </div>
              <div className='box long'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='40'
                  height='40'
                  viewBox='0 0 40 40'
                  fill='none'>
                  <path
                    d='M14.2854 18.5714C18.2303 18.5714 21.4283 15.3734 21.4283 11.4285C21.4283 7.48362 18.2303 4.28564 14.2854 4.28564C10.3405 4.28564 7.14258 7.48362 7.14258 11.4285C7.14258 15.3734 10.3405 18.5714 14.2854 18.5714Z'
                    fill='#FC7A01'
                    stroke='#FC7A01'
                    strokeWidth='2.85714'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M1.42773 38.571H27.142V37.0221C27.1193 34.8444 26.5449 32.7079 25.4727 30.8124C24.4004 28.9167 22.8652 27.3239 21.0104 26.1825C19.1556 25.041 17.0418 24.3884 14.8664 24.2854C14.6724 24.2762 14.4785 24.2714 14.2849 24.271C14.0912 24.2714 13.8973 24.2762 13.7034 24.2854C11.528 24.3884 9.41416 25.041 7.55936 26.1825C5.70459 27.3239 4.16936 28.9167 3.09708 30.8124C2.02481 32.7079 1.45048 34.8444 1.42773 37.0221V38.571Z'
                    fill='#FC7A01'
                    stroke='#FC7A01'
                    strokeWidth='2.85714'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M25.7129 18.5714C29.6577 18.5714 32.8557 15.3734 32.8557 11.4285C32.8557 7.48362 29.6577 4.28564 25.7129 4.28564'
                    fill='#FC7A01'
                  />
                  <path
                    d='M25.7129 18.5714C29.6577 18.5714 32.8557 15.3734 32.8557 11.4285C32.8557 7.48362 29.6577 4.28564 25.7129 4.28564'
                    stroke='#FC7A01'
                    strokeWidth='2.85714'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M32.856 38.5713H38.5703V37.0221C38.5475 34.8444 37.9732 32.7079 36.9009 30.8124C35.8286 28.9167 34.2935 27.3239 32.4386 26.1825C31.2397 25.4447 29.9323 24.9111 28.5703 24.5981'
                    fill='#FC7A01'
                  />
                  <path
                    d='M32.856 38.5713H38.5703V37.0221C38.5475 34.8444 37.9732 32.7079 36.9009 30.8124C35.8286 28.9167 34.2935 27.3239 32.4386 26.1825C31.2397 25.4447 29.9323 24.9111 28.5703 24.5981'
                    stroke='#FC7A01'
                    strokeWidth='2.85714'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p className='title'>
                  <Counter from={0} to={4000} /> annual service customers
                </p>
              </div>
            </div>
          </div>
        )}

        <div className='middle'>
          <div className='wrap'>
            <div className='left'>
              <Link to={"/"} aria-label='Britannia Pharmacy Logo'>
                <img src={Logo} alt='Logo' />
              </Link>
              <div className='textwrap'>
                <p>
                  <strong>
                    Address: <br />
                  </strong>
                  <a
                    href='https://maps.app.goo.gl/HVgWiHRut4SpqrH18'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: "#6d6d6d" }}>
                    15749 Highway 7 Perth, Ontario K7H 0J2
                  </a>
                </p>
                <p>
                  <strong>
                    Phone: <br />
                  </strong>
                  <a href='tel:+8006459639' style={{ color: "#6d6d6d" }}>
                    800 645 9639
                  </a>
                </p>
                <p>
                  <strong>
                    Email: <br />
                  </strong>
                  <a
                    href='mailto: info@valleywatertreatment.ca​'
                    style={{ color: "#6d6d6d" }}>
                    info@valleywatertreatment.ca​
                  </a>
                </p>
              </div>
            </div>
            <div className='right'>
              <div className='upper'>
                <div className='coulmn'>
                  <p className='title'>Account</p>
                  <div className='list'>
                    {/* <Link to='/'>My Account</Link> */}
                    {/* <Link to='/'>Login</Link> */}
                    <Link to='/shop'>Shop</Link>
                    <Link to='/cart'>Cart</Link>
                    <Link to='/wishlist'>Wishlist</Link>
                  </div>
                </div>
                <div className='coulmn'>
                  <p className='title'>Services</p>
                  <div className='list'>
                    <Link to='/services/plumping'>Plumbing</Link>
                    <Link to='/services/water-quotations'>
                      Water Treatment{" "}
                    </Link>
                    <Link to='/services/heating-quotations'>Heating</Link>
                    <Link to='/RebateProgram'>Rebate Program</Link>
                    <Link to='/schedule-annual-service'>Annual Service</Link>
                  </div>
                </div>
                <div className='coulmn'>
                  <p className='title'>Valley</p>
                  <div className='list'>
                    <Link to='/about'>About Us</Link>
                    <Link to='/contact'>Contact Us</Link>
                  </div>
                </div>
              </div>
              <div className='lower'>
                <div
                  style={{ textAlign: "center" }}
                  className='Footer-PoweredBy-Text Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400'>
                  Powered by{" "}
                  <span>
                    <svg
                      className='InlineSVG Icon Footer-PoweredBy-Icon Icon--md'
                      focusable='false'
                      width='33'
                      height='15'
                      role='img'
                      color='purple'
                      aria-labelledby='stripe-title'>
                      <title id='stripe-title'>Stripe</title>
                      <g fillRule='evenodd'>
                        <path d='M32.956 7.925c0-2.313-1.12-4.138-3.261-4.138-2.15 0-3.451 1.825-3.451 4.12 0 2.719 1.535 4.092 3.74 4.092 1.075 0 1.888-.244 2.502-.587V9.605c-.614.307-1.319.497-2.213.497-.876 0-1.653-.307-1.753-1.373h4.418c0-.118.018-.588.018-.804zm-4.463-.859c0-1.02.624-1.445 1.193-1.445.55 0 1.138.424 1.138 1.445h-2.33zM22.756 3.787c-.885 0-1.454.415-1.77.704l-.118-.56H18.88v10.535l2.259-.48.009-2.556c.325.235.804.57 1.6.57 1.616 0 3.089-1.302 3.089-4.166-.01-2.62-1.5-4.047-3.08-4.047zm-.542 6.225c-.533 0-.85-.19-1.066-.425l-.009-3.352c.235-.262.56-.443 1.075-.443.822 0 1.391.922 1.391 2.105 0 1.211-.56 2.115-1.39 2.115zM18.04 2.766V.932l-2.268.479v1.843zM15.772 3.94h2.268v7.905h-2.268zM13.342 4.609l-.144-.669h-1.952v7.906h2.259V6.488c.533-.696 1.436-.57 1.716-.47V3.94c-.289-.108-1.346-.307-1.879.669zM8.825 1.98l-2.205.47-.009 7.236c0 1.337 1.003 2.322 2.34 2.322.741 0 1.283-.135 1.581-.298V9.876c-.289.117-1.716.533-1.716-.804V5.865h1.716V3.94H8.816l.009-1.96zM2.718 6.235c0-.352.289-.488.767-.488.687 0 1.554.208 2.241.578V4.202a5.958 5.958 0 0 0-2.24-.415c-1.835 0-3.054.957-3.054 2.557 0 2.493 3.433 2.096 3.433 3.17 0 .416-.361.552-.867.552-.75 0-1.708-.307-2.467-.723v2.15c.84.362 1.69.515 2.467.515 1.879 0 3.17-.93 3.17-2.548-.008-2.692-3.45-2.213-3.45-3.225z'></path>
                      </g>
                    </svg>
                  </span>
                </div>
                {Array.from({ length: 6 }, (_, i) => i + 1).map((i, index) => (
                  <a
                    href='https://www.financeit.io/'
                    key={index}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <img alt='payment option' src={`/cards/${i}.png`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className='lower'>
          <div className='wrap'>
            <div className='social'>
              <a
                aria-label='Social Media URL'
                href='https://www.instagram.com/valleyplumbingheatingandwater/'
                target='_blank'
                rel='noopener noreferrer'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'>
                  <g clipPath='url(#clip0_28_1800)'>
                    <path
                      d='M8 1.44062C10.1375 1.44062 10.3906 1.45 11.2313 1.4875C12.0125 1.52187 12.4344 1.65313 12.7156 1.7625C13.0875 1.90625 13.3563 2.08125 13.6344 2.35938C13.9156 2.64062 14.0875 2.90625 14.2313 3.27813C14.3406 3.55938 14.4719 3.98438 14.5063 4.7625C14.5438 5.60625 14.5531 5.85938 14.5531 7.99375C14.5531 10.1313 14.5438 10.3844 14.5063 11.225C14.4719 12.0063 14.3406 12.4281 14.2313 12.7094C14.0875 13.0813 13.9125 13.35 13.6344 13.6281C13.3531 13.9094 13.0875 14.0813 12.7156 14.225C12.4344 14.3344 12.0094 14.4656 11.2313 14.5C10.3875 14.5375 10.1344 14.5469 8 14.5469C5.8625 14.5469 5.60938 14.5375 4.76875 14.5C3.9875 14.4656 3.56563 14.3344 3.28438 14.225C2.9125 14.0813 2.64375 13.9063 2.36563 13.6281C2.08438 13.3469 1.9125 13.0813 1.76875 12.7094C1.65938 12.4281 1.52813 12.0031 1.49375 11.225C1.45625 10.3813 1.44688 10.1281 1.44688 7.99375C1.44688 5.85625 1.45625 5.60313 1.49375 4.7625C1.52813 3.98125 1.65938 3.55938 1.76875 3.27813C1.9125 2.90625 2.0875 2.6375 2.36563 2.35938C2.64688 2.07812 2.9125 1.90625 3.28438 1.7625C3.56563 1.65313 3.99063 1.52187 4.76875 1.4875C5.60938 1.45 5.8625 1.44062 8 1.44062ZM8 0C5.82813 0 5.55625 0.009375 4.70313 0.046875C3.85313 0.084375 3.26875 0.221875 2.7625 0.41875C2.23438 0.625 1.7875 0.896875 1.34375 1.34375C0.896875 1.7875 0.625 2.23438 0.41875 2.75938C0.221875 3.26875 0.084375 3.85 0.046875 4.7C0.009375 5.55625 0 5.82812 0 8C0 10.1719 0.009375 10.4438 0.046875 11.2969C0.084375 12.1469 0.221875 12.7313 0.41875 13.2375C0.625 13.7656 0.896875 14.2125 1.34375 14.6562C1.7875 15.1 2.23438 15.375 2.75938 15.5781C3.26875 15.775 3.85 15.9125 4.7 15.95C5.55313 15.9875 5.825 15.9969 7.99688 15.9969C10.1688 15.9969 10.4406 15.9875 11.2938 15.95C12.1438 15.9125 12.7281 15.775 13.2344 15.5781C13.7594 15.375 14.2063 15.1 14.65 14.6562C15.0938 14.2125 15.3688 13.7656 15.5719 13.2406C15.7688 12.7313 15.9063 12.15 15.9438 11.3C15.9813 10.4469 15.9906 10.175 15.9906 8.00313C15.9906 5.83125 15.9813 5.55938 15.9438 4.70625C15.9063 3.85625 15.7688 3.27188 15.5719 2.76562C15.375 2.23438 15.1031 1.7875 14.6563 1.34375C14.2125 0.9 13.7656 0.625 13.2406 0.421875C12.7313 0.225 12.15 0.0875 11.3 0.05C10.4438 0.009375 10.1719 0 8 0Z'
                      fill='#272934'
                    />
                    <path
                      d='M8 3.89062C5.73125 3.89062 3.89062 5.73125 3.89062 8C3.89062 10.2688 5.73125 12.1094 8 12.1094C10.2688 12.1094 12.1094 10.2688 12.1094 8C12.1094 5.73125 10.2688 3.89062 8 3.89062ZM8 10.6656C6.52813 10.6656 5.33437 9.47188 5.33437 8C5.33437 6.52813 6.52813 5.33437 8 5.33437C9.47188 5.33437 10.6656 6.52813 10.6656 8C10.6656 9.47188 9.47188 10.6656 8 10.6656Z'
                      fill='#272934'
                    />
                    <path
                      d='M13.2312 3.72793C13.2312 4.25918 12.8 4.68731 12.2719 4.68731C11.7406 4.68731 11.3125 4.25606 11.3125 3.72793C11.3125 3.19668 11.7438 2.76855 12.2719 2.76855C12.8 2.76855 13.2312 3.19981 13.2312 3.72793Z'
                      fill='#272934'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_28_1800'>
                      <rect width='16' height='16' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href='https://www.facebook.com/valleyplumbingheatingandwatertreatment/'
                target='_blank'
                aria-label='Social Media URL'
                rel='noopener noreferrer'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'>
                  <g clipPath='url(#clip0_28_1804)'>
                    <path
                      d='M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 11.993 2.92547 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77172 3.125C10.6467 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.56 5.25 9.25 5.86672 9.25 6.5V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z'
                      fill='#272934'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_28_1804'>
                      <rect width='16' height='16' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href='https://www.linkedin.com/company/valley-water-plumbing-treatment/?originalSubdomain=ca'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Social Media URL'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='16'
                  viewBox='0 0 15 16'
                  fill='none'>
                  <path
                    d='M14.0795 1.70956V14.2904C14.0795 14.5781 13.9705 14.8539 13.7763 15.0573C13.5822 15.2607 13.3189 15.375 13.0443 15.375H1.03526C0.760692 15.375 0.49737 15.2607 0.303221 15.0573C0.109072 14.8539 0 14.5781 0 14.2904L0 1.70956C0 1.42192 0.109072 1.14605 0.303221 0.94266C0.49737 0.739266 0.760692 0.625 1.03526 0.625L13.0443 0.625C13.3189 0.625 13.5822 0.739266 13.7763 0.94266C13.9705 1.14605 14.0795 1.42192 14.0795 1.70956ZM4.14104 6.26471H2.07052V13.2059H4.14104V6.26471ZM4.32739 3.87868C4.32848 3.7146 4.29871 3.55191 4.23978 3.39988C4.18086 3.24786 4.09392 3.10948 3.98394 2.99266C3.87397 2.87583 3.7431 2.78285 3.59882 2.71901C3.45454 2.65517 3.29967 2.62172 3.14305 2.62059H3.10578C2.78728 2.62059 2.48183 2.75314 2.25662 2.98907C2.0314 3.22501 1.90488 3.54501 1.90488 3.87868C1.90488 4.21234 2.0314 4.53234 2.25662 4.76828C2.48183 5.00422 2.78728 5.13676 3.10578 5.13676C3.26241 5.1408 3.41826 5.11247 3.56444 5.05338C3.71061 4.99429 3.84424 4.90561 3.95768 4.7924C4.07113 4.6792 4.16217 4.54368 4.22561 4.3936C4.28904 4.24352 4.32363 4.08181 4.32739 3.91772V3.87868ZM12.009 8.98912C12.009 6.90243 10.7419 6.09118 9.48299 6.09118C9.07081 6.06955 8.66042 6.16153 8.29275 6.35792C7.92509 6.55431 7.613 6.84826 7.38762 7.21044H7.32965V6.26471H5.38336V13.2059H7.45388V9.51404C7.42395 9.13594 7.53764 8.76073 7.77025 8.46993C8.00286 8.17913 8.3356 7.99623 8.69619 7.96096H8.77487C9.4333 7.96096 9.92194 8.39478 9.92194 9.48802V13.2059H11.9925L12.009 8.98912Z'
                    fill='#272934'
                  />
                </svg>
              </a>
            </div>
            <p className='rights'>
              © 2023 Valley. All Rights Reserved. Designed & Developed by{" "}
              <a href='https://www.webelocity.io/'>Webelocity</a>
            </p>
            <div className='privacy'>
              <Link to='/shipping-policy'>Shipping Policy</Link>

              <Link to='/privacy-policy'>Privacy Policy</Link>
              <Link to='/Terms-and-Conditions'>Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
